/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostoneloginaccountsPostOneLoginAccountsResult
 */
export interface JumboPostoneloginaccountsPostOneLoginAccountsResult {
    /**
     * 
     * @type {string}
     * @memberof JumboPostoneloginaccountsPostOneLoginAccountsResult
     */
    tokenID?: string;
}

/**
 * Check if a given object implements the JumboPostoneloginaccountsPostOneLoginAccountsResult interface.
 */
export function instanceOfJumboPostoneloginaccountsPostOneLoginAccountsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboPostoneloginaccountsPostOneLoginAccountsResultFromJSON(json: any): JumboPostoneloginaccountsPostOneLoginAccountsResult {
    return JumboPostoneloginaccountsPostOneLoginAccountsResultFromJSONTyped(json, false);
}

export function JumboPostoneloginaccountsPostOneLoginAccountsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostoneloginaccountsPostOneLoginAccountsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tokenID': !exists(json, 'tokenID') ? undefined : json['tokenID'],
    };
}

export function JumboPostoneloginaccountsPostOneLoginAccountsResultToJSON(value?: JumboPostoneloginaccountsPostOneLoginAccountsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tokenID': value.tokenID,
    };
}

